module.exports = __webpack_public_path__ + "static/brochure-52cea19e55431f3bddc53a874ee0acc5.png";